import { useLocalStore } from 'mobx-react';
import { focused, meeting as meetingModel, members, transcribe } from '@/models';
import { find } from 'lodash';
import { message } from '@/components';
import { useIntl } from 'umi';
enum focusModeStatus {
  focused = 1,
  unFocused = 2,
}
export interface FocusedChangeResp {
  channelId: string;
  focusModeStatus: focusModeStatus;
  focusOnMemberUid: string; // 用户userId
  focusOnMemberDeviceId: ''; // 用户deviceId
  state: 0;
}
export default function useFocusedChange() {
  const { formatMessage } = useIntl();

  const { meeting } = useLocalStore(() => {
    return {
      meeting: meetingModel,
    };
  });

  const change = async (body: FocusedChangeResp) => {
    if (isMobile) {
      return;
    }
    if (body.focusModeStatus === focusModeStatus.focused) {
      const { focusOnMemberUid } = body;
      if (focused?.focusedYuxid && focusOnMemberUid) {
        message.info({
          content: formatMessage({ id: 'enableChangeFocusedTa' }),
          noIcon: true,
        });
      } else {
        message.info({
          content: formatMessage({ id: 'enableAllFocusedTa' }),
          noIcon: true,
        });
      }

      const focusedYuxid = find(
        meeting.sortMembers,
        (member) => member.uid === focusOnMemberUid
      )?.yxUidStr;
      focused?.setFocusedYuxid(focusedYuxid || '');
    } else {
      message.info({
        content: formatMessage({ id: 'disabledAllFocusedTa' }),
        noIcon: true,
      });
      focused?.setFocusedYuxid('');
    }
  };

  return change;
}
